// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__1diOE","footer":"ModalCreateQualiphyProcedure_footer__3MvmP","additionData":"ModalCreateQualiphyProcedure_additionData__iRuTJ"};